import { useEffect, useState, type ReactNode } from "react";
import { MoonIcon, SunIcon, SystemThemeIcon } from "./icons.js";

type Theme = "light" | "dark" | "system";

function apply(theme: Theme) {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => (localStorage.getItem("msf-theme") as Theme) ?? "system");

  useEffect(() => {
    apply(theme);
    localStorage.setItem("msf-theme", theme);
  }, [theme]);

  const next: Record<Theme, Theme> = { system: "light", light: "dark", dark: "system" };
  const icon: Record<Theme, ReactNode> = {
    system: <SystemThemeIcon className="h-5 w-5" />,
    light: <SunIcon className="h-5 w-5" />,
    dark: <MoonIcon className="h-5 w-5" />,
  };

  return (
    <button
      type="button"
      onClick={() => setTheme((t) => next[t])}
      className="clay-btn grid h-10 w-10 place-items-center"
      aria-label={`Theme: ${theme}`}
      title={`Theme: ${theme}`}
    >
      {icon[theme]}
    </button>
  );
}
